import { Component, OnInit, Input } from '@angular/core';
import { Book } from '../model/book.model';
import { BookService } from '../services/book.service';


@Component({
  selector: 'bs-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  @Input() private books :Book[];

  constructor(private bookService :BookService) { }

  ngOnInit() {
  }

  onDelete(id :number) :void{
    // console.log('Deleting book ', id);
    this.bookService.remove(id); 
  }

}
